<template>
  <div>Authentication...</div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth-store'
import { useRouter } from 'vue-router'

export default defineComponent({
  setup() {
    const authStore = useAuthStore()
    const { replace } = useRouter()

    onMounted(async () => {
      await authStore
        .handleRedirectCallback()
        .then(() => {
          let returnUrl = authStore.returnUrl || '/'
          if (!returnUrl.startsWith('/') || returnUrl.startsWith('//')) {
            returnUrl = '/'
          }
          replace(returnUrl)
        })
        .catch((error) => {
          console.error('Error handling sign-in callback:', error)
        })
    })
  },
})
</script>
